export default __webpack_public_path__ + "static/media/565.a872d17c.png";